import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';

type SaveTableTemplateDialogProps = {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
};

const SaveTableTemplateDialog = ({ open, loading, onClose, onSave }: SaveTableTemplateDialogProps) => {
  // useState hooks
  const [name, setName] = useState('');

  // useEffect hooks
  useEffect(() => {
    if (open) setName('');
  }, [open]);

  return (
    <Dialog open={open} onClose={() => !loading && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>
        <FormattedMessage id="datagrid.saveTemplate" defaultMessage="Şablon Kaydet" />
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TextField
          autoFocus
          fullWidth
          label={<FormattedMessage id="datagrid.templateName" defaultMessage="Şablon adı" />}
          value={name}
          disabled={loading}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 1.5 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
          onClick={() => void onSave(name.trim())}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveTableTemplateDialog;
